// extracted by mini-css-extract-plugin
export var commonCard = "CommonCard-module--commonCard--65398";
export var commonCardButtons = "CommonCard-module--commonCardButtons--04abf";
export var commonCardContainer = "CommonCard-module--commonCardContainer--f74a9";
export var commonCardContent = "CommonCard-module--commonCardContent--7ed73";
export var commonCardHeading = "CommonCard-module--commonCardHeading--2d6ff";
export var commonCardImage = "CommonCard-module--commonCardImage--2de9d";
export var commonCardLink = "CommonCard-module--commonCardLink--601a6";